var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"index-head"},[_c(_vm.isComponent,{tag:"component",attrs:{"isNav":_vm.isNav,"isHome":_vm.isHome}})],1),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"index-foot"},[_c('foot')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cfa357","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = null
// module chunks = 